<template>
  <v-row v-on:click="toggleCard()">

      <transition name="flip">
        <v-col v-bind:key="data.flipped">
          <section v-if="!data.flipped" class="card card-front">
            <section class="section-image" :style="sectionStyle">
              <v-img
                v-bind:src="url_photo"
                class="img-photo"
                fixed
              >
              </v-img>
            </section>
            <section class="section-title pl-2 pr-2">
              <h3 style="font-weight: 300;" class="text-uppercase">{{ data.name }}</h3>
            </section>

            <section class="section-flag">
              <v-img
                v-bind:src="url_flag"
                class="img-flag"
                fixed
              >
              </v-img>
            </section>

            <section class="section-position pl-2 pr-2">
              <h5 style="font-weight: 300;" class="text--secondary">{{ data.last_position }}</h5>
            </section>

            <section class="section-social">
              <a v-if="data.web" :href="data.web" target="_blank">
                <v-icon>
                  mdi-web
                </v-icon>
              </a>

              <a v-if="data.linkedin" :href="data.linkedin" target="_blank">
                <v-icon>
                  mdi-linkedin
                </v-icon>
              </a>
              
              <a v-if="data.facebook" :href="data.facebook" target="_blank">
                <v-icon>
                  mdi-facebook
                </v-icon>
              </a>
              
              <a v-if="data.instagram" :href="data.instagram" target="_blank">
                <v-icon>
                  mdi-instagram
                </v-icon>
              </a>

              <a v-if="data.twitter" :href="data.twitter" target="_blank">
                <v-icon>
                  mdi-twitter
                </v-icon>
              </a>

              <a v-if="data.youtube" :href="data.youtube" target="_blank">
                <v-icon>
                  mdi-youtube
                </v-icon>
              </a>

              <a v-if="data.whatsapp" :href="data.whatsapp" target="_blank">
                <v-icon>
                  mdi-whatsapp
                </v-icon>
              </a>

              <a v-if="data.email" :href="'mailto:'+data.email" target="_blank">
                <v-icon>
                  mdi-email
                </v-icon>
              </a>
            </section>
            
          </section>

          <section 
            v-if="data.flipped" 
            class="card card-back overflow-auto">
            <p class="text--secondary card-description">
              {{ data.description }}
            </p>
          </section>  
        </v-col>
      </transition>

  </v-row>
</template>
<script>
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'cardSpeaker',
    props:['data', 'backgroundCard'],

    data: () => ({
      show_card:false,
      loading:false,
      flipped: false,
      newFront: '',
      newBack: '',
      error: false,

      url_photo:null,
      base_url: null
    }),
    methods:{
      createURL(){
        this.url_photo = this.base_url + this.data.photo
        this.url_flag = this.base_url + this.data.country.flag
        this.show_card = true
      },

      toggleCard: function() {
        this.data.flipped = !this.data.flipped;
      }
    },
    computed: {
      sectionStyle() {
        return {
          backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.9)), url(${this.backgroundCard})`
        }
      }
    },
    created() {
      this.base_url = APP_URL
      this.createURL()
    }
  }
</script>

<style type='text/css' scoped>
ul {
  padding-left: 0;
  display: flex;
  flex-flow: row wrap;
}

li {
  list-style-type: none;
  padding: 10px 10px;
  transition: all 0.3s ease;
}

.container {
  max-width: 100%;
  padding: 2em;
}
.card {
  outline: 1px solid #E0E0E0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 350px;
  width: 220px!important;
  cursor: pointer;
  background-color: #ffffff;
  border-radius: 6px;
  line-height: 27px;
  position: relative;
  color: #000000;
  box-shadow: 0 0 15px rgb(0 0 0 / 0.2);
}
.card-front {
  display: block;
  text-align: center;
  font-weight: 300;
  font-size: 18px;
}
.card-back {
  margin: auto; /* Centra el contenido verticalmente */
  text-align: center; /* Centra el contenido horizontalmente */
  font-weight: 400;
  font-size: 13px;
  padding-left: 10px;
  padding-right: 10px;
}
.card-description {
  line-height: 1.5; 
  justify-content: center;
  align-items: center;
}

.img-photo {
  max-height: 116px;
  max-width: 116px;
  min-height: 116px;
  min-width: 116px;
  border-radius: 50%; 
}

.img-flag{
  height: auto;
  max-width: 32px;
}

.section-image {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 140px;
  width: 220px;
  background-size: contain;
  background-repeat: repeat;
  background-position: center;
}

.section-title {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
}

.section-flag {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}

.section-position {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 76px;
  font-size: 18px;
}

.section-social {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}

li:hover{
  transform: scale(1.02);
}

.flip-enter-active {
  transition: all .9s ease;
}

.flip-leave-active {
  display: none;
}

.flip-enter, .flip-leave {
  transform: rotateY(180deg);
  opacity: 0;

}

/* Form */
.flashcard-form{
  position: relative;
}


label{
  font-weight: 400;
  color: #333;
  margin-right: 10px;
}

input{
  border-radius: 5px;
  border: 2px solid #eaeaea;
  padding: 10px;
  outline: none;
}

button{
  border-radius: 5px;
  border: 1px solid #87cb84;
  background-color: #87cb84;
  padding: 8px 15px;
  outline: none;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
}

button:hover{
  background-color: #70a66f;
}

.error{
  margin-top: 10px;
  display: block;
  color: #e44e42;
  font-weight: 600;
}
</style>